import { Record, Map as ImmutableMap } from 'immutable';
import * as OwnerAssignmentTypes from 'automation-ui-action-features/owner-assignment/OwnerAssignmentTypes';
export default class OwnerAssignment extends Record({
  type: OwnerAssignmentTypes.NONE,
  ownerId: null,
  ownerProperty: null
}, 'OwnerAssignment') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap);
  }
}